module.exports = __webpack_public_path__ + "static/media/apple.f4a40d27.png";